import { render, staticRenderFns } from "./DocSelectForm.vue?vue&type=template&id=080fcc2a&scoped=true&"
import script from "./DocSelectForm.vue?vue&type=script&lang=js&"
export * from "./DocSelectForm.vue?vue&type=script&lang=js&"
import style0 from "./DocSelectForm.vue?vue&type=style&index=0&id=080fcc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fcc2a",
  null
  
)

export default component.exports